import { IInputConfig, IInput } from "./Input";
import { IElementContainer } from "./ElementContainer";
import { InputFactory } from "./InputFactory";

export interface IFieldConfig extends IInputConfig
{
	id?: string;
	label?: string;
	units?: string;
	type?: string;
	min?: Number;
	max?: Number;
	value?: Number;
}

export class Field implements IElementContainer
{
	public static fieldsById:{[key:string]: Field} = {};

	public id: string;
	private _element: HTMLElement;
	private _input: IInput;

	constructor(config: IFieldConfig, label?: string)
	{
		this.id = config.id;

		this._element = document.createElement("div");
		this._element.className = "utils-field";
		this._element.setAttribute("data-id", config.id);

		var labelElement = document.createElement("label");
		label = label === "Inset bay" ? " insetbay" : "";
		labelElement.className = "utils-label" + label;
		labelElement.textContent = config.label || "";

		this._input = InputFactory.createFromConfig(config);
		this._element.appendChild(labelElement);
		this._element.appendChild(this._input.element);

		if (config.units)
		{
			var unitsSpan = document.createElement("span");
			unitsSpan.className = "unitsSpan";
			unitsSpan.textContent = config.units;
			this._element.appendChild(unitsSpan);
		}

		Field.fieldsById[config.id] = this;
	}

	private createLabel()
	{
		var label = document.createElement("label");
	}

	public enable()
	{
		this._element.classList.remove("disabled");
		this._input.enable();
	}

	public disable()
	{
		this._element.classList.add("disabled");
		this._input.disable();
	}

	public isDisabled()
	{
		return this._element.classList.contains("disabled");
	}

	public get element()
	{
		return this._element;
	}

	public get input()
	{
		return this._input;
	}
}